import React from 'react';

export default class Algebra extends React.Component {

  constructor(props) {
    super(props);
  }

  render(){
    return (
      <div className="equation-display">
        <p className="equation-display__equation">
          {this.props.currentEquation}
        </p>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/algebra_problem_display.js
 **/